export default class Lightbox {
    constructor(galx) {
        this.plural= galx.length > 1
        this.galx= galx
        this.init()
    }

    init() {
        if(this.plural) {
            this.galx.forEach(gal => {
                this.gatGalleryImages(gal)
                gal.addEventListener('click', this.clickHandler, false)
            })
        } else {
            this.galx.addEventListener('click', this.clickHandler, false)
        }
    }

    gatGalleryImages(parent){
        const images= parent.querySelectorAll('img')
        images.forEach(img => {
            this.preloadImage(img)
        })
    }

    preloadImage(img){
        var preloadLink = document.createElement("link")
        preloadLink.href = img.src
        preloadLink.rel = "preload"
        preloadLink.as = "image"
        document.head.appendChild(preloadLink)
    }

    clickHandler(e) {
        if (e.target.tagName === 'IMG') {
            const fullFigure = document.createElement('figure')
            const overlay = document.createElement('div')
            const page = document.getElementById('page')

            overlay.className= 'overlay'
            overlay.style.display= 'block'
            page.appendChild(overlay)

            fullFigure.className = 'jsFullFigure'
            fullFigure.style.position = 'fixed'
            fullFigure.style.zIndex = '999'
            page.appendChild(fullFigure)

            var myImg = document.createElement('img')
            var imgLoc = e.target.src

            /*var a= imgLoc.split('-')

            var replace = '-' + a[a.length-1]
            var re = new RegExp(replace,"g")

            var msg = imgLoc.replace(re, "")*/

            myImg.src = imgLoc

            fullFigure.style.left = '0'
            fullFigure.style.right = '0'
            fullFigure.style.top = '0'
            fullFigure.style.bottom = '0'

            fullFigure.appendChild(myImg)

            fullFigure.addEventListener('click', function handler(d) {
                this.parentNode.removeChild(this)
                overlay.parentNode.removeChild(overlay)
                this.removeEventListener('click', handler, false)
            }, false)
        }
    }
}